import { Link } from 'react-router';
import { articlesIndex, site } from '../data';
import { countInlineMath, MathText } from '../dvi/MathText';
import { formatMonthDay, warekiYear } from '../lib/wareki';

/** サイト文面の数式 DVI (build-tex 生成)。順序は hero → about の通し番号 */
const SITE_FORMULAS_URL = '/site/meta.formulas.dvi';

function SiteText({ text, pageOffset }: { text: string; pageOffset: number }) {
  return (
    <MathText
      text={text}
      formulasUrl={SITE_FORMULAS_URL}
      pages={site.metaPages ?? null}
      pageOffset={pageOffset}
    />
  );
}

function groupHistoryByYear() {
  const groups: { year: string; entries: { date: string; text: string }[] }[] = [];
  for (const entry of articlesIndex.history) {
    const year = warekiYear(entry.date);
    const last = groups[groups.length - 1];
    if (last && last.year === year) {
      last.entries.push(entry);
    } else {
      groups.push({ year, entries: [entry] });
    }
  }
  return groups;
}

export function Home() {
  const historyGroups = groupHistoryByYear();
  return (
    <>
      <div className="hero">
        <h1>
          <SiteText text={site.hero.title} pageOffset={0} />
        </h1>
        <p>
          <SiteText text={site.hero.lead} pageOffset={countInlineMath(site.hero.title)} />
        </p>
      </div>
      {articlesIndex.categories.map((category) => (
        <section className="card" key={category.key}>
          <h2>
            <Link to={`/${category.key}`}>{category.title}</Link>
          </h2>
          <p>{category.lead}</p>
          <ul className="content-links">
            {category.children.map((child) => (
              <li key={child.key}>
                <Link to={`/${category.key}/${child.key}`}>{child.title}</Link>
              </li>
            ))}
          </ul>
        </section>
      ))}
      <section className="card">
        <h2>更新履歴</h2>
        {historyGroups.map((group) => (
          <div key={group.year}>
            <h3>{group.year}</h3>
            <ul className="history-list">
              {group.entries.map((entry, i) => (
                <li key={`${entry.date}-${i}`}>
                  <span className="history-date">{formatMonthDay(entry.date)}</span>
                  <span>{entry.text}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </section>
      <section className="card">
        <h2>コンタクト</h2>
        <h3>何者か</h3>
        {site.contact.about.map((paragraph, i) => (
          <p key={i}>
            <SiteText
              text={paragraph}
              pageOffset={
                countInlineMath(site.hero.title) +
                countInlineMath(site.hero.lead) +
                site.contact.about.slice(0, i).reduce((sum, p) => sum + countInlineMath(p), 0)
              }
            />
          </p>
        ))}
        {site.contact.accounts.map((account) => (
          <div key={account.service}>
            <h3>{account.service}</h3>
            <p>
              <a href={account.url} target="_blank" rel="noreferrer">
                {account.id}
              </a>
              を使っています。
            </p>
          </div>
        ))}
        <h3>メール</h3>
        <p>{site.contact.emailNote}</p>
        <p className="framed">{site.contact.email}</p>
      </section>
    </>
  );
}
